import React from 'react';
import { ChartCard } from '../../dashboard';

export default function HorizontalBarList({ title, data = [], color = '#7c3aed' }) {
  const max = Math.max(1, ...data.map((d) => d.value));
  // Round the axis ceiling up to a friendly step so the gridline labels look clean.
  const step = max <= 10 ? 5 : max <= 50 ? 25 : max <= 200 ? 25 : 50;
  const axisMax = Math.ceil(max / step) * step || step;
  const ticks = [0, 0.25, 0.5, 0.75, 1].map((f) => Math.round(axisMax * f));

  return (
    <ChartCard title={title} empty={!data.length} emptyHeight={160}>
      <div className="space-y-4">
        {data.map((d) => {
          const pct = Math.min(100, (d.value / axisMax) * 100);
          return (
            <div key={d.name} className="flex items-center gap-3">
              <span className="w-24 sm:w-28 shrink-0 text-xs text-gray-600 truncate" title={d.name}>
                {d.name}
              </span>
              <div className="flex-1 relative h-2.5 bg-gray-100 rounded-full">
                <div
                  className="absolute inset-y-0 left-0 rounded-full transition-all"
                  style={{ width: `${pct}%`, backgroundColor: color }}
                />
              </div>
              <span className="w-8 shrink-0 text-right text-xs font-semibold text-gray-700">
                {d.value}
              </span>
            </div>
          );
        })}

        <div className="flex justify-between pl-24 sm:pl-28 pr-8 pt-1 text-[10px] text-gray-400">
          {ticks.map((t) => (
            <span key={t}>{t}</span>
          ))}
        </div>
      </div>
    </ChartCard>
  );
}
